module.exports = __webpack_public_path__ + "img/how_con_02.7e13692c.png";